﻿import Swiper, {Navigation, Pagination} from 'swiper';
import { default as config } from '../../Project/configuration';   
import { utils } from '../../Foundation';

export class SwiperContainer {
    constructor(element) {
        // Media query
        if (!window.matchMedia("(max-width: "+ config.mq.md +")").matches) {
            return false;
        }

        // References
        this.container = utils.hasId(element) ? utils.toId(element.getAttribute('id')) : utils.toClass(element.getAttribute('class'));
        this.pagination = this.container + '> .swiper-pagination';

        // Properties
        this.data = element.dataset.swiper;
        this.options = {...this.settings, ...this.data};

        // configure Swiper to use modules
        Swiper.use([Navigation, Pagination]);

        // Initiate
        new Swiper(this.container, this.options);
    }

    get settings () {
        return {
            speed: 600,
            navigation: { 
                nextEl: `${this.container} .swiper-button-next`,
                prevEl: `${this.container} .swiper-button-prev`
            },
            spaceBetween: 20,
            centeredSlides: true,
            pagination: {
                el: this.pagination
            }
        }
    }
}